import styled from 'styled-components';

export const Heading = styled('h4')`
  ${({ theme }) => theme.typography.largeStrong}
`;

export const GraphWrapper = styled('div')`
  height: 140px;
`;
